import SideBar from "./SideBar/Sidebar";
import SideBarData from "./SideBar/SideBarData";
import { Outlet, useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import { createContext, useEffect, useState } from "react";
import {  ToastContainer } from "react-toastify";
import { WebsiteSetting } from "../../../Components/Utils";
import { useFetchLatestWebsiteSettingsQuery } from "../../../stores/api/settings.api";
export const AdminContext = createContext();
const getInitialDarkMode = () => {
  if (typeof window === "undefined") return false;
  const storedValue = localStorage.getItem("admin-dark-mode");
  if (storedValue !== null) return storedValue === "true";
  return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches ?? false;
};
const AdminLayout = () => {
  const { data: settings } = useFetchLatestWebsiteSettingsQuery();
  const { pathname } = useLocation();
  const companyName = settings?.website_name || "Directorate Of MD&EHS Rehabilitation Department Government Of Sindh";
  const [dark, setDark] = useState(getInitialDarkMode);

  // Page-wise meta: tab title reflects the current admin page + company name
  useEffect(() => {
    const segs = pathname.split("/").filter(Boolean);
    let last = segs[segs.length - 1] || "dashboard";
    // ignore trailing ids (uuid or numeric) → use the section segment instead
    if (/^\d+$/.test(last) || /^[0-9a-f]{8}-[0-9a-f-]+$/i.test(last)) {
      last = segs[segs.length - 2] || "dashboard";
    }
    const pretty = last.replace(/[-_]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    document.title = `${pretty} · ${companyName}`;
  }, [pathname, companyName]);

  // Favicon served from /favicon.ico (kept in sync by backend on settings save)
  useEffect(() => {
    if (!settings?.favicon) return;
    document.querySelectorAll("link[rel*='icon']").forEach((el) => el.remove());
    const el = document.createElement("link");
    el.setAttribute("rel", "icon");
    el.setAttribute("href", `/favicon.ico?v=${Date.now()}`);
    document.head.appendChild(el);
  }, [settings]);
  const [expanded, setExpanded] = useState(true);
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < 768 : false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("admin-dark-mode", dark.toString());
  }, [dark]);

  return (
    <AdminContext.Provider value={{ dark, setDark, isMobile, setIsMobile, expanded, setExpanded, mobileOpen, setMobileOpen }}>
      <div className="flex h-screen bg-gray-50 text-gray-900 dark:bg-slate-950 dark:text-gray-100">
        {/* Sidebar — hidden on mobile, shown via offcanvas */}
        <div className="hidden md:block">
          <SideBar>
            <SideBarData />
          </SideBar>
        </div>

        {/* Mobile offcanvas overlay */}
        {mobileOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 md:hidden"
            onClick={() => setMobileOpen(false)}
          />
        )}

        {/* Mobile offcanvas drawer */}
        <div className={`fixed top-0 left-0 h-full z-50 md:hidden transition-transform duration-300 ease-in-out ${mobileOpen ? "translate-x-0" : "-translate-x-full"}`}>
          <SideBar>
            <SideBarData />
          </SideBar>
        </div>

        {/* Main Content */}
        <main className="flex-1 overflow-auto min-w-0">
          <TopBar />
          <div className="p-3 m-2 bg-white rounded shadow-sm dark:bg-slate-800"><Outlet /></div>
        </main>
        <ToastContainer />
      </div>
    </AdminContext.Provider>
  );
};

export default AdminLayout;